export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Represents a date without time */
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  URI: { input: unknown; output: unknown };
  URITemplate: { input: unknown; output: unknown };
};

export type Action = {
  __typename?: "Action";
  /** Primary argument for the action. */
  arg?: Maybe<Scalars["String"]["output"]>;
  /** Text for the button (only used for promo redeem at present). */
  buttonText?: Maybe<Scalars["String"]["output"]>;
  /** Pre-requisites to perform the action. Note: the order is important. */
  requirements?: Maybe<Array<ActionRequirements>>;
  /** The action to perform when the user taps the card. */
  type: ActionType;
};

export enum ActionRequirements {
  /** The user must confirm the purchase via a dialog */
  ConfirmBuy = "CONFIRM_BUY",
  /** The user must have Facebook publish permissions */
  FacebookPublish = "FACEBOOK_PUBLISH",
  /** The user must provide the app with location services / GPS permissions */
  Gps = "GPS",
  /** The user must have payments connected (Aston Club) */
  Payments = "PAYMENTS",
  /** The user must have a payment method (eg: valid credit card) */
  PaymentMethod = "PAYMENT_METHOD",
}

export enum ActionType {
  DisplayDetails = "DISPLAY_DETAILS",
  OkDialog = "OK_DIALOG",
  OpenUrl = "OPEN_URL",
  PromptAuth = "PROMPT_AUTH",
  RedeemPromo = "REDEEM_PROMO",
  ResendVerification = "RESEND_VERIFICATION",
}

/** Represents a single activity for a user */
export type Activity = {
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** The name of the location this activity was at */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** The time this activity or event occurred */
  timestamp: Scalars["Date"]["output"];
  /** Title string */
  title: Scalars["String"]["output"];
};

/** Results for an activity query */
export type ActivityResult = {
  __typename?: "ActivityResult";
  /** The items for the query results */
  items: Array<Activity>;
  /** Pagination information */
  pageInfo: PageInfo;
  summary: ActivitySummary;
};

/** Summary for the MyActivity section */
export type ActivitySummary = {
  __typename?: "ActivitySummary";
  credit: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  points: Scalars["Int"]["output"];
};

export type AddWalletInput = {
  /** DBS is no args - if returnURL is provided the PayLah app will bounce to this */
  returnURL?: InputMaybe<Scalars["String"]["input"]>;
  /** Masterpass only */
  token?: InputMaybe<Scalars["String"]["input"]>;
};

/** Results for an addWallet request */
export type AddWalletResult = MutationResult & {
  __typename?: "AddWalletResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method data */
  paymentMethods?: Maybe<Array<PaymentMethod>>;
};

export type Address = {
  __typename?: "Address";
  country?: Maybe<Scalars["String"]["output"]>;
  locality?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
  street2?: Maybe<Scalars["String"]["output"]>;
};

export type AddressAutocomplete = {
  __typename?: "AddressAutocomplete";
  /** Friendly display name that summarises the entire address details. Useful for concise display. */
  name: Scalars["String"]["output"];
  /** Ref for the full address, pass it to address query to resolve to AddressDetails */
  ref: Scalars["String"]["output"];
};

export type AddressDelivery = {
  __typename?: "AddressDelivery";
  apartment?: Maybe<Scalars["String"]["output"]>;
  coords: Coords;
  country: Scalars["String"]["output"];
  locality: Scalars["String"]["output"];
  postcode: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  streetAddress: Scalars["String"]["output"];
};

export type AddressDetails = {
  __typename?: "AddressDetails";
  /** The geocoordinates of the address (lat, lng) */
  coords: Coords;
  /** The country, eg United Kingdom, Australia */
  country: Scalars["String"]["output"];
  /** The suburb or similar locality (sub-region) */
  locality: Scalars["String"]["output"];
  /** Friendly display name that summarises the entire address details. Useful for concise display. */
  name: Scalars["String"]["output"];
  /** The post code for this address */
  postcode: Scalars["String"]["output"];
  /** The region, province, etc */
  region: Scalars["String"]["output"];
  /** Street address (unit + number + name) */
  streetAddress: Scalars["String"]["output"];
};

/** Represents a failure to query address details */
export type AddressDetailsError = {
  __typename?: "AddressDetailsError";
  /** The message for an error */
  message: Scalars["String"]["output"];
};

export type AddressDetailsResponse = {
  __typename?: "AddressDetailsResponse";
  /** If successful provides the requested details */
  details?: Maybe<AddressDetails>;
  /** If unsuccessful this will be set and indicates why the query failed */
  error?: Maybe<AddressDetailsError>;
};

/** App review score */
export enum AppScore {
  Bad = "BAD",
  Good = "GOOD",
}

/** Authorize payment result extends a mutation result, but also provides the nonce for the payment in the event of success */
export type AuthorizePaymentResult = MutationResult & {
  __typename?: "AuthorizePaymentResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method nonce */
  nonce?: Maybe<Scalars["String"]["output"]>;
};

/** DEPRECATED */
export type AuthorizedPayment = {
  __typename?: "AuthorizedPayment";
  nonce: Scalars["String"]["output"];
};

export type Balance = {
  __typename?: "Balance";
  /** Amount of credit available at this location */
  credit?: Maybe<Scalars["Int"]["output"]>;
  /** Retrieves the customer's available credit at this location, formatted into a string. */
  creditText?: Maybe<Scalars["String"]["output"]>;
  /** Returns points balance formatted appropriately to use in the app header. */
  pointsText?: Maybe<Scalars["String"]["output"]>;
};

/** Bill Payments config */
export type BillPaymentConfig = {
  __typename?: "BillPaymentConfig";
  /** text to prompt for ref (bill/register number) */
  refPromptText: Scalars["String"]["output"];
};

export type BillPaymentOption = PaymentOption & {
  __typename?: "BillPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** text to prompt for ref (bill/register number) */
  refPromptText: Scalars["String"]["output"];
  scanner: ScannerBehaviour;
  scannerTitle?: Maybe<Scalars["String"]["output"]>;
};

export type BooleanKeyValue = KeyValue & {
  __typename?: "BooleanKeyValue";
  boolValue?: Maybe<Scalars["Boolean"]["output"]>;
  dataType: ValueType;
  key: Scalars["String"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Braintree specific metadata about a gateway. */
export type BraintreeVzeroMetadata = PaymentsMetadata & {
  __typename?: "BraintreeVzeroMetadata";
  /** The public/client token for adding/tokenising new payment methods. */
  clientToken: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always Braintree type. */
  type: PaymentsType;
};

export type Card = {
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayType?: Maybe<CardDisplayType>;
  id: Scalars["String"]["output"];
  /** Width and height will be applied if possible via image resizer. */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Catch all general info text that may be displayed in certain situations */
  infoText?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CardDisplayType {
  /** Order with delivery card */
  Delivery = "DELIVERY",
  /** Full sized card with image */
  Image = "IMAGE",
  /** Order ahead card */
  Order = "ORDER",
  /** Thin Facebook card (check-in) */
  Social = "SOCIAL",
  /** Verification required card */
  Verification = "VERIFICATION",
}

/** Metadata specific to a CARDSTREAM gateway. */
export type CardstreamMetadata = PaymentsMetadata & {
  __typename?: "CardstreamMetadata";
  /**
   * Open this URL in webview (GET) to be redirected to the add card page.
   * (optionally send returnUrl as a query param to override where to be redirected to on completion).
   */
  addCardPageGetUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Always CARDSTREAM type. */
  type: PaymentsType;
};

export type Cart = {
  __typename?: "Cart";
  fulfillmentType?: Maybe<FulfillmentType>;
  items: Array<CartItem>;
  locationId: Scalars["String"]["output"];
  locationRef: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Date"]["output"];
};

export type CartAdjustment = {
  __typename?: "CartAdjustment";
  /**
   * The amount of the adjustment. Discounts will be negative, and surcharges
   * positive. This is a tax-inclusive amount.
   */
  amount: Scalars["Int"]["output"];
  /** The ID of the adjustment */
  id: Scalars["String"]["output"];
  /** The items affected by this adjustment */
  itemsAffected?: Maybe<Array<CartItemAffectedRef>>;
  /** Descriptive text to be displayed to the customer for this adjustment */
  label: Scalars["String"]["output"];
  /** The amount of tax included in this adjustment. */
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
};

export type CartItem = {
  __typename?: "CartItem";
  id: Scalars["String"]["output"];
  itemType?: Maybe<CartItemType>;
  note?: Maybe<Scalars["String"]["output"]>;
  options: Array<CartItemOption>;
  quantity: Scalars["Int"]["output"];
};

export type CartItemAffectedRef = {
  __typename?: "CartItemAffectedRef";
  /** The index of the item in the cart that this adjustment applies to */
  index: Scalars["Int"]["output"];
  /** The quantity of this item that this adjustment applies to */
  quantity: Scalars["Int"]["output"];
};

export type CartItemChoice = {
  __typename?: "CartItemChoice";
  id: Scalars["String"]["output"];
  options: Array<CartItemOption>;
  quantity: Scalars["Int"]["output"];
};

export type CartItemChoiceInput = {
  id: Scalars["String"]["input"];
  options: Array<CartItemOptionInput>;
  quantity: Scalars["Int"]["input"];
};

export type CartItemInput = {
  id: Scalars["String"]["input"];
  itemType?: InputMaybe<CartItemType>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  options: Array<CartItemOptionInput>;
  quantity: Scalars["Int"]["input"];
};

export type CartItemOption = {
  __typename?: "CartItemOption";
  choices: Array<CartItemChoice>;
  id: Scalars["String"]["output"];
};

export type CartItemOptionInput = {
  choices: Array<CartItemChoiceInput>;
  id: Scalars["String"]["input"];
};

/** Cart Item Type (Deal or Product) */
export enum CartItemType {
  Deal = "deal",
  Product = "product",
}

export type CheckIn = {
  __typename?: "CheckIn";
  canUpdatePaymentMethod: Scalars["Boolean"]["output"];
  chargeTotal?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated No longer returned in the new CheckIn format */
  expired: Scalars["Boolean"]["output"];
  expires?: Maybe<Scalars["Date"]["output"]>;
  finish?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  /**
   * Defined if the check in has a limit (typically a bar tab).
   * @deprecated No longer returned in the new CheckIn format
   */
  limit?: Maybe<Scalars["String"]["output"]>;
  /** Defined if the check in has a limit (typically a bar tab). */
  limitRemaining?: Maybe<Scalars["String"]["output"]>;
  /** The name of the location matching the requested ID (convenience field). */
  locationName: Scalars["String"]["output"];
  /** Message can be displayed to user on completion of check-out */
  message?: Maybe<Scalars["String"]["output"]>;
  number: Scalars["String"]["output"];
  paymentMethod?: Maybe<PaymentMethod>;
  /** If successful indicates the amount of points earned during the check in */
  pointsEarned?: Maybe<Scalars["Int"]["output"]>;
  /** Mobile app should display this formatted one instead of using pointsEarned (int) */
  pointsEarnedFormatted?: Maybe<Scalars["String"]["output"]>;
  qrCode?: Maybe<QrCode>;
  start: Scalars["Date"]["output"];
  transactions?: Maybe<Array<Transaction>>;
};

export type CheckInByIdInput = {
  id: Scalars["String"]["input"];
  includeExpired?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CheckInPaymentOption = PaymentOption & {
  __typename?: "CheckInPaymentOption";
  action: PaymentAction;
  hasLimit: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

/** Check in result extends a mutation result, but also provides the check in in the event of success */
export type CheckInResult = MutationResult & {
  __typename?: "CheckInResult";
  /** If successful provides the check in data */
  checkIn?: Maybe<CheckIn>;
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

export type CheckOutResult = MutationResult & {
  __typename?: "CheckOutResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** Message can be displayed to user on completion of check-out */
  message?: Maybe<Scalars["String"]["output"]>;
  /** If successful indicates the amount of points earned during the check in */
  pointsEarned?: Maybe<Scalars["Int"]["output"]>;
  /** Mobile app should display this formatted one instead of using pointsEarned (int) */
  pointsEarnedFormatted?: Maybe<Scalars["String"]["output"]>;
};

/** DEPRECATED */
export type CheckOutResultV1 = {
  __typename?: "CheckOutResultV1";
  pointsEarned?: Maybe<Scalars["Int"]["output"]>;
};

/** Returns an inventory item if successful, null if item has already been claimed, or an error if a failure */
export type ClaimItemResult = MutationResult & {
  __typename?: "ClaimItemResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful and the promotion is an item reward type, this will provide newly created inventory item object */
  inventoryItem?: Maybe<InventoryItem>;
};

/** Payment method result extends a mutation result, but also provides the payment method in the event of success */
export type ClaimPromotionResult = MutationResult & {
  __typename?: "ClaimPromotionResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful and the promotion is an item reward type, this will provide newly created inventory item object */
  inventoryItem?: Maybe<InventoryItem>;
};

export type CodePreview = {
  __typename?: "CodePreview";
  description?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  rewardType?: Maybe<PromotionRewardType>;
};

/** Complete order result extends a mutation result, but also the boolean for indicating if it's the first order for the customer */
export type CompleteOrderResult = MutationResult & {
  __typename?: "CompleteOrderResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will indicate if this order was made by a newCustomer */
  newCustomer: Scalars["Boolean"]["output"];
};

export type ContactDetails = {
  __typename?: "ContactDetails";
  deliveryAddress: Array<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
};

export type Coords = {
  __typename?: "Coords";
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type CoordsInput = {
  lat: Scalars["Float"]["input"];
  lng: Scalars["Float"]["input"];
};

/** Contains an OrderSession just like CreateOrderResult */
export type CreateBillPaymentResult = MutationResult & {
  __typename?: "CreateBillPaymentResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

/** The result of creating a cart */
export type CreateCartResult = MutationResult & {
  __typename?: "CreateCartResult";
  /** adjustments */
  adjustments?: Maybe<Array<CartAdjustment>>;
  /** Discounts */
  discounts?: Maybe<Array<Discount>>;
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

/** Authorize payment result extends a mutation result, but also provides the nonce for the payment in the event of success */
export type CreateOrderResult = MutationResult & {
  __typename?: "CreateOrderResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** @deprecated Moved into OrderSession */
  requirePhoneVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

export type Credit = {
  __typename?: "Credit";
  amount: Scalars["Int"]["output"];
  created: Scalars["Date"]["output"];
  expires: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  remaining: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type CreditExpiredActivity = Activity & {
  __typename?: "CreditExpiredActivity";
  credit: Credit;
  id: Scalars["String"]["output"];
  locationName?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

export type Customer = {
  __typename?: "Customer";
  /** URL to a profile photo for the user. */
  avatar?: Maybe<Scalars["String"]["output"]>;
  /** A list of payment methods (eg: credit cards) available (will be empty list if user has not created a wallet). */
  canEditProfile: Scalars["Boolean"]["output"];
  /**
   * The date the user was created.
   * @deprecated No business logic regarding this
   */
  created: Scalars["Date"]["output"];
  /** Retrieves the customer's available credit at this location, formatted into a string. */
  creditsFormatted?: Maybe<Scalars["String"]["output"]>;
  /** The user's dob as a string (eg: 1980-01-01). */
  dob?: Maybe<Scalars["String"]["output"]>;
  /** The user's email address (and username). Note: this CAN be null for users that sign up with Facebook. */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** The user's first name. */
  firstName: Scalars["String"]["output"];
  /**
   * The user's gender (should probably be enum - MALE, FEMALE).
   * @deprecated No business logic regarding this
   */
  gender?: Maybe<Scalars["String"]["output"]>;
  /** Has the user accepted T&Cs in their profile */
  hasAgreedToTerms: Scalars["Boolean"]["output"];
  /** Returns true if the customer has at least 1 payment method available on their wallet (if they have a wallet). */
  hasPaymentMethod: Scalars["Boolean"]["output"];
  /** Returns true if the customer has payments (Aston Club wallet) connected. */
  hasPayments: Scalars["Boolean"]["output"];
  /** The user's unique ID. */
  id: Scalars["String"]["output"];
  /** Inventory */
  inventory: Array<InventoryItem>;
  /** Returns true if the customer has verified their payments (wallet), ie: mobile number verification. Returns false if payments not set up. */
  isPaymentsVerified: Scalars["Boolean"]["output"];
  /** The user's last name. */
  lastName: Scalars["String"]["output"];
  /** Returns true if the customer is allowed to edit their profile. */
  paymentMethods: Array<PaymentMethod>;
  /** The user's mobile phone number. */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the customer's available loyalty points. */
  points: Scalars["Int"]["output"];
  /** Returns points balance formatted appropriately to use in the app header. */
  pointsText: Scalars["String"]["output"];
  /** Returns true if the user has completed setting up user profile. */
  profileComplete: Scalars["Boolean"]["output"];
  /** Unique ID to be used for analytics tracking. */
  trackingId: Scalars["String"]["output"];
  /** The timestamp this customer was verified (null if not verified). */
  verified?: Maybe<Scalars["Date"]["output"]>;
};

export type CustomerCreditsFormattedArgs = {
  location: Scalars["String"]["input"];
};

/**
 * Customer-facing fees per billing classification. Field names are the aston
 * billing classifications with the slash removed, eg order/pickup -> orderPickup.
 */
export type CustomerFees = {
  __typename?: "CustomerFees";
  appCredit: FeeValues;
  appItem: FeeValues;
  orderDelivery: FeeValues;
  orderExternal: FeeValues;
  orderPickup: FeeValues;
  orderService: FeeValues;
  posBill: FeeValues;
  posCheckin: FeeValues;
};

/** Metadata specific to a DBS gateway (Wirecard only). */
export type DbsCardMetadata = PaymentsMetadata & {
  __typename?: "DBSCardMetadata";
  /** Open in webview to be re-directed to the add card page. */
  addCardPagePostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox (UAT) API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always DBS_CARD type. */
  type: PaymentsType;
};

/** Metadata specific to a DBS gateway. */
export type DbsMetadata = PaymentsMetadata & {
  __typename?: "DBSMetadata";
  /** Append card details and POST this invisibly (ie: hidden view or like API call). */
  addCardDirectPostUrl: Scalars["String"]["output"];
  /** Open in webview to be re-directed to the add card page. */
  addCardPagePostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox (UAT) API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always DBS type. */
  type: PaymentsType;
};

export enum DayOfTheWeek {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export type DealChoice = {
  __typename?: "DealChoice";
  defaultQuantity: Scalars["Int"]["output"];
  maxQuantity: Scalars["Int"]["output"];
  minQuantity: Scalars["Int"]["output"];
  productDef: ProductDef;
};

export type DealOption = {
  __typename?: "DealOption";
  choices?: Maybe<Array<DealChoice>>;
  id: Scalars["String"]["output"];
  maxQuantity?: Maybe<Scalars["Int"]["output"]>;
  minQuantity: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type DefaultCard = Card & {
  __typename?: "DefaultCard";
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayType?: Maybe<CardDisplayType>;
  id: Scalars["String"]["output"];
  /** Width and height will be applied if possible via image resizer. */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  infoText?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DefaultCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DeliveryAddress = {
  /** Street address (apartment/unit/suite + number) */
  apartment?: InputMaybe<Scalars["String"]["input"]>;
  /** The geocoordinates of the address (lat, lng) */
  coords?: InputMaybe<CoordsInput>;
  /** The country, eg United Kingdom, Australia */
  country: Scalars["String"]["input"];
  /** The suburb or similar locality (sub-region) */
  locality: Scalars["String"]["input"];
  /** The post code for this address */
  postcode: Scalars["String"]["input"];
  /** The region, province, etc */
  region: Scalars["String"]["input"];
  /** Street address (unit + number + name) */
  streetAddress: Scalars["String"]["input"];
};

export type DeliveryAddressStatus = {
  __typename?: "DeliveryAddressStatus";
  messages: Array<Scalars["String"]["output"]>;
  valid: Scalars["Boolean"]["output"];
};

export type DeliveryCard = Card & {
  __typename?: "DeliveryCard";
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  /** Final delivery timestamp if available or falls back to max timestamp specified in the settings */
  deliveryAtMax?: Maybe<Scalars["Date"]["output"]>;
  /** Final delivery timestamp if available or falls back to min timestamp specified in the settings */
  deliveryAtMin?: Maybe<Scalars["Date"]["output"]>;
  /** When there is a deliveryTimestamp, display it with this prefix */
  deliveryETAPrefix: Scalars["String"]["output"];
  /** Else display this text, ie: "Delivery in 20-30 mins!" */
  deliveryMessage: Scalars["String"]["output"];
  /**
   * DEPRECATED Delivery state === order state
   * @deprecated Use deliveryStatus
   */
  deliveryState: DeliveryState;
  /** ie: pending, in_transit */
  deliveryStatus?: Maybe<DeliveryStatus>;
  /**
   * Delivery
   * ETA, null, or final delivery timestamp (if available)
   * Needs to be a timestamp so the phone can display user time
   * @deprecated Use deliveryAtMax
   */
  deliveryTimestamp?: Maybe<Scalars["Date"]["output"]>;
  /** Unused */
  details?: Maybe<Scalars["String"]["output"]>;
  /** DELIVERY */
  displayType?: Maybe<CardDisplayType>;
  /** Common */
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Will contain friendly delivery info if available ie: "They are on their way to you" */
  infoText?: Maybe<Scalars["String"]["output"]>;
  /** Location name */
  locationName: Scalars["String"]["output"];
  /**
   * Order
   * Current state of this order.
   */
  state: OrderState;
  /** Time this order was created. */
  timestamp: Scalars["Date"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  /** Total cost of this order formatted. */
  totalFormatted: Scalars["String"]["output"];
};

export type DeliveryCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DeliveryPaymentOption = PaymentOption & {
  __typename?: "DeliveryPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  /** Override "Thankyou for helping our the drivers..." on the first Delivery modal */
  introText?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  /** Override "I'm ordering from" displayed in multiple places */
  locationConfirmText?: Maybe<Scalars["String"]["output"]>;
};

/** Deprecated, same as order state */
export enum DeliveryState {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  New = "NEW",
  Success = "SUCCESS",
}

export enum DeliveryStatus {
  DriverAtDropoff = "driver_at_dropoff",
  DriverAtPickup = "driver_at_pickup",
  DriverEnRouteToPickup = "driver_en_route_to_pickup",
  Failed = "failed",
  InTransit = "in_transit",
  LookingForDriver = "looking_for_driver",
  Pending = "pending",
  Success = "success",
}

export type Discount = {
  __typename?: "Discount";
  /** Discount amount based on order total */
  discountAmount: Scalars["Int"]["output"];
  /** The included tax of the discount */
  discountTax?: Maybe<Scalars["Int"]["output"]>;
  /** Unique ID for this discount. */
  id: Scalars["String"]["output"];
  /** ID of the item the discount is being applied to */
  itemId?: Maybe<Scalars["String"]["output"]>;
  /** Name or description of discount */
  name: Scalars["String"]["output"];
  /**
   * Rate, ie: 0.5 is 50% off
   * @deprecated Use discountAmount instead
   */
  rate: Scalars["Float"]["output"];
};

/** FatZebra specific metadata about a gateway */
export type FatZebraCardMasterpassMetadata = PaymentsMetadata & {
  __typename?: "FatZebraCardMasterpassMetadata";
  /** The full URL to direct post. */
  directPostUrl: Scalars["String"]["output"];
  /** URL to web page for managing MasterPass. */
  masterpassManageUrl?: Maybe<Scalars["String"]["output"]>;
  /** URL for pairing MasterPass. */
  masterpassPairingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Configured redirection URL. */
  returnPath: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
  /** Verification hash. */
  verification: Scalars["String"]["output"];
};

/** FatZebra specific metadata about a gateway. */
export type FatZebraCardMetadata = PaymentsMetadata & {
  __typename?: "FatZebraCardMetadata";
  /** The full URL to direct post. */
  directPostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Configured redirection URL. */
  returnPath: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
  /** Verification hash. */
  verification: Scalars["String"]["output"];
};

/** FatZebra specific metadata about a gateway */
export type FatZebraMasterpassMetadata = PaymentsMetadata & {
  __typename?: "FatZebraMasterpassMetadata";
  /** URL to web page for managing MasterPass. */
  masterpassManageUrl?: Maybe<Scalars["String"]["output"]>;
  /** URL to web page for pairing MasterPass. */
  masterpassPairingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
};

/** Represents a feature flag key/value pair */
export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
};

/** A single fee: a flat component plus a proportional one. */
export type FeeValues = {
  __typename?: "FeeValues";
  /** Flat component, in the smallest currency unit (eg cents). */
  base: Scalars["Int"]["output"];
  /** Proportional component as a fraction of the amount, eg 0.02 for 2%. */
  rate: Scalars["Float"]["output"];
};

export enum FulfillmentType {
  Delivery = "DELIVERY",
  PickUp = "PICK_UP",
  Service = "SERVICE",
}

/** Minimal RedeemCode response */
export type GenericMessageDetails = MessageDetails & {
  __typename?: "GenericMessageDetails";
  message: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export enum InputType {
  Datepicker = "DATEPICKER",
  Keyboard = "KEYBOARD",
  List = "LIST",
  /** The user should input a valid store/location based on merchant locations */
  LocationSelector = "LOCATION_SELECTOR",
  Toggle = "TOGGLE",
}

export type IntKeyValue = KeyValue & {
  __typename?: "IntKeyValue";
  dataType: ValueType;
  intValue?: Maybe<Scalars["Int"]["output"]>;
  key: Scalars["String"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export type InventoryItem = {
  __typename?: "InventoryItem";
  /** Display text that represents the code for this item. This will typically be the contents of the QR code or barcode. */
  codeText?: Maybe<Scalars["String"]["output"]>;
  /** URL to a code (barcode/QR code/etc) that represents this inventory item. */
  codeUrl?: Maybe<Scalars["String"]["output"]>;
  /** When the item was gifted to, or purchased by, the customer. */
  created: Scalars["Date"]["output"];
  /** When the item expires. */
  expires?: Maybe<Scalars["Date"]["output"]>;
  /** Unique ID of the item - use this with the item collection process. */
  id: Scalars["String"]["output"];
  /**
   * Image to display when viewing the item (not currently in use, but it's coming).
   * Width and height will be applied if possible via image resizer.
   */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use.
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Whether the item was a purchase or not. */
  purchased: Scalars["Boolean"]["output"];
  /** Text to display with the item (title in Saved Offers list). */
  title: Scalars["String"]["output"];
  /** The type currently has COLLECTION and CODE. */
  type: InventoryType;
};

export type InventoryItemImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum InventoryType {
  /** The inventory has a barcode */
  Code = "CODE",
  /** The inventory is a normal promotion */
  Collection = "COLLECTION",
}

export type Item = {
  __typename?: "Item";
  claimed?: Maybe<Scalars["Date"]["output"]>;
  claimedLocation?: Maybe<Scalars["String"]["output"]>;
  expires?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ItemAffectedRef = {
  index: Scalars["Int"]["input"];
  quantity: Scalars["Int"]["input"];
};

export type ItemExpiredActivity = Activity & {
  __typename?: "ItemExpiredActivity";
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Item */
  item: Item;
  /** Location if relevant for the event */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Event time */
  timestamp: Scalars["Date"]["output"];
  /** Title */
  title: Scalars["String"]["output"];
};

/** Represents an order passed from the Tidy Javascript Payment Interface (eg: pre-orders) */
export type JsInterfaceOrder = {
  /** Optionally limits the payment to a specific client */
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  /** Option items metadata */
  items?: InputMaybe<Array<InputMaybe<JsInterfaceOrderItem>>>;
  /** The Aston ID of the merchant to be charged for this order. This is REQUIRED unless an orderStoreId is provided. */
  merchantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional reference ID (order ID, check ID, invoice ID). Only used for metadata. */
  orderRef?: InputMaybe<Scalars["String"]["input"]>;
  /** The third party store ID of the store to be charged for this order. This will only work if the store-merchant mapping has been set up correctly. */
  orderStoreId?: InputMaybe<Scalars["String"]["input"]>;
  /** Total amount of tax included in the order IN DOLLARS. (Optional) */
  tax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Optional title of the order. will be displayed to the user in the prompt. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Total amount of the order INCLUSIVE OF TAX in DOLLARS. */
  total: Scalars["Float"]["input"];
};

export type JsInterfaceOrderItem = {
  amount: Scalars["Float"]["input"];
  name: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  tax?: InputMaybe<Scalars["Float"]["input"]>;
};

export type KeyValue = {
  /** The value type */
  dataType: ValueType;
  /** String key for the key value pair */
  key: Scalars["String"]["output"];
  /** String representation of the value (numbers and booleans are also represented as strings) */
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum KeyboardType {
  Default = "DEFAULT",
  DefaultMasked = "DEFAULT_MASKED",
  Email = "EMAIL",
  Number = "NUMBER",
  NumberMasked = "NUMBER_MASKED",
  Phone = "PHONE",
}

export type LegalItem = {
  __typename?: "LegalItem";
  title: Scalars["String"]["output"];
  url: Scalars["URI"]["output"];
};

export type Location = {
  __typename?: "Location";
  address?: Maybe<Address>;
  billsEnabled: Scalars["Boolean"]["output"];
  checkInEnabled: Scalars["Boolean"]["output"];
  coords?: Maybe<Coords>;
  distance?: Maybe<Scalars["Float"]["output"]>;
  externalMenuUrl?: Maybe<Scalars["String"]["output"]>;
  hasPayments: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  /** The code a user must enter to initialise item collection. NOTE: will be null if legacy "staff-must-press" flow should be used. */
  itemCollectionCode?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  openingHours?: Maybe<Scalars["String"]["output"]>;
  orderAheadEnabled: Scalars["Boolean"]["output"];
  orderAtTableEnabled: Scalars["Boolean"]["output"];
  orderDeliveryEnabled: Scalars["Boolean"]["output"];
  paymentOptions: Array<PaymentOption>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  preorder?: Maybe<LocationPreorder>;
  slug?: Maybe<Scalars["String"]["output"]>;
  social?: Maybe<LocationSocialLinks>;
  timezone: Scalars["String"]["output"];
  uid: Scalars["String"]["output"];
  website?: Maybe<Scalars["String"]["output"]>;
};

export type LocationDeal = {
  __typename?: "LocationDeal";
  availability?: Maybe<Array<Period>>;
  description?: Maybe<Scalars["String"]["output"]>;
  endAt?: Maybe<Scalars["String"]["output"]>;
  exclusive: Scalars["Boolean"]["output"];
  fulfillmentType?: Maybe<Array<FulfillmentType>>;
  hidden: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  options: Array<DealOption>;
  plu: Scalars["String"]["output"];
  startAt?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type LocationPreorder = {
  __typename?: "LocationPreorder";
  id: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type LocationSocialLinks = {
  __typename?: "LocationSocialLinks";
  facebook?: Maybe<Scalars["String"]["output"]>;
  instagram?: Maybe<Scalars["String"]["output"]>;
  twitter?: Maybe<Scalars["String"]["output"]>;
  yelp?: Maybe<Scalars["String"]["output"]>;
  youtube?: Maybe<Scalars["String"]["output"]>;
};

export enum LoginProvider {
  Apple = "APPLE",
  Email = "EMAIL",
  Facebook = "FACEBOOK",
  Google = "GOOGLE",
  Guest = "GUEST",
  Link = "LINK",
}

/** Available actions for menu items */
export enum MenuAction {
  /** App tour (no longer a feature) */
  AppTour = "APP_TOUR",
  /** Open a URL in the external browser */
  Browser = "BROWSER",
  /** Display the card list screen (home screen) */
  CardList = "CARD_LIST",
  /** Display the contact screen */
  Contact = "CONTACT",
  /** Open a URL in the embedded web screen */
  Embedded = "EMBEDDED",
  /** Open the history screen (My Activity) */
  History = "HISTORY",
  /** Display the payment screen (payment methods / wallet) */
  Payment = "PAYMENT",
  /** Display the user profile screen (profile view/edit) */
  Profile = "PROFILE",
  /** Register a new user */
  Register = "REGISTER",
  /** Display the saved offers screen */
  SavedOffers = "SAVED_OFFERS",
  /** Display the settings scren */
  Settings = "SETTINGS",
  /** Display the support screen */
  Support = "SUPPORT",
  /** Display the vouchers screen (voucher code entry) */
  Vouchers = "VOUCHERS",
  /** Open a URL in the internal / web view browser */
  Webview = "WEBVIEW",
}

export type MenuItem = {
  __typename?: "MenuItem";
  action?: Maybe<MenuAction>;
  iconUrl?: Maybe<Scalars["String"]["output"]>;
  params?: Maybe<Array<KeyValue>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type MenuProductItem = ProductItem & {
  __typename?: "MenuProductItem";
  amount: Scalars["Int"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** may differ from the standard product amount */
  displayAmount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  options: Array<ProductOption>;
  tags: Array<Scalars["String"]["output"]>;
};

export type MenuV2 = {
  __typename?: "MenuV2";
  categories?: Maybe<Array<ProductCategoryV2>>;
  fulfillmentType?: Maybe<Array<FulfillmentType>>;
  id: Scalars["String"]["output"];
  serviceAvailability?: Maybe<Array<Period>>;
  title: Scalars["String"]["output"];
};

/** A merchant represents the merchant for an entire application. */
export type Merchant = {
  __typename?: "Merchant";
  /** Link to App on Google Play Store */
  androidStoreUrl?: Maybe<Scalars["String"]["output"]>;
  /** Apple web client id for merchant */
  appleWebClientId?: Maybe<Scalars["String"]["output"]>;
  /** Currency code. */
  currency: Scalars["String"]["output"];
  /** Currency decimal digits, eg 2 for AUD/USD, 0 for JPY. */
  currencyDecimalDigits: Scalars["Int"]["output"];
  /** Maps a external location ref to matching Location */
  externalLocation?: Maybe<Location>;
  /** Google Client Id for this merchant (optionally). */
  googleClientId?: Maybe<Scalars["String"]["output"]>;
  /** Hide Google Pay (currently app only) */
  googlePayDisabled: Scalars["Boolean"]["output"];
  googleTagId?: Maybe<Scalars["String"]["output"]>;
  gtmId?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for the merchant (integer as string). */
  id: Scalars["String"]["output"];
  /** Link to App on ios Store */
  iosStoreUrl?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use Query.location */
  location?: Maybe<Location>;
  /**
   * Locations/stores/sites for this merchant, optionally sorted by distance to myLocation.
   * @deprecated Use Query.locations
   */
  locations?: Maybe<Array<Location>>;
  /** Meta Pixel ID for pixel tracking/analytics */
  metaPixelId?: Maybe<Scalars["String"]["output"]>;
  /** Display name of the merchant. */
  name: Scalars["String"]["output"];
  /**
   * Custom name of merchant receiving payment
   * This might be displayed when customer is confirming payment in apple/google pay
   */
  payName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Metadata about the configured payment gateway.
   * @deprecated We only support Stripe now. Use stripePublishableKey.
   */
  paymentsMetadata?: Maybe<PaymentsMetadata>;
  /**
   * DEPRECATED Payment client token (eg: Braintree client token).
   * @deprecated This was for legacy Braintree. Use stripePublishableKey.
   */
  paymentsToken?: Maybe<Scalars["String"]["output"]>;
  /** Settings defined for this merchant. */
  settings: MerchantSettings;
  /** Merchant name in stripe */
  stripeMerchantName: Scalars["String"]["output"];
  /** Publishable/public Key to use for stripe */
  stripePublishableKey?: Maybe<Scalars["String"]["output"]>;
  /** The unique UID for the merchant. */
  uid: Scalars["String"]["output"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantExternalLocationArgs = {
  ref: Scalars["String"]["input"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantLocationArgs = {
  locationRef: Scalars["String"]["input"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantLocationsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  myLocation?: InputMaybe<CoordsInput>;
  nativeOrderingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MerchantSettings = {
  __typename?: "MerchantSettings";
  authEndpoint?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotAPIKey?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotPackageName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotUsername?: Maybe<Scalars["String"]["output"]>;
  btnPayInStore: Scalars["String"]["output"];
  btnPreorder: Scalars["String"]["output"];
  externalOrderingUrl?: Maybe<Scalars["String"]["output"]>;
  guestOrderingEnabled: Scalars["Boolean"]["output"];
  loginProviders: Array<LoginProvider>;
  requirePhoneWeb: Scalars["Boolean"]["output"];
  requireVerification: Scalars["Boolean"]["output"];
  /** @deprecated use location payment options */
  showPayButton: Scalars["Boolean"]["output"];
  showScanCode?: Maybe<Scalars["Boolean"]["output"]>;
  termsAndConditionsURL: Scalars["String"]["output"];
  tipRatios: Array<Scalars["Float"]["output"]>;
};

export type Message = {
  __typename?: "Message";
  text?: Maybe<Scalars["String"]["output"]>;
  timestamp?: Maybe<Scalars["Date"]["output"]>;
};

export type MessageActivity = Activity & {
  __typename?: "MessageActivity";
  /** The message body */
  body: Scalars["String"]["output"];
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** This is always null for messages at present */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** The timestamp of the message */
  timestamp: Scalars["Date"]["output"];
  /** The message title */
  title: Scalars["String"]["output"];
};

/** Minimum information that will be provided by RedeemCode */
export type MessageDetails = {
  message: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** Standard response for a mutation + a message */
export type MessageMutationResult = MutationResult & {
  __typename?: "MessageMutationResult";
  /** If unsuccessful this will be set and indicates why the mutation failed. Will be null if successful. */
  error?: Maybe<MutationError>;
  /** Success message to be displayed to the user. Will be null if there is an error. */
  message?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** DEPRECATED. Adds a new payment method */
  addPaymentMethod: PaymentMethod;
  /** Adds a new payment method */
  addPaymentMethodV2: PaymentMethodResult;
  /** Adds or connects a third party wallet, eg: MasterPass, PayLah */
  addWallet: AddWalletResult;
  associatePaymentMethod: StandardMutationResult;
  /** DEPRECATED. Authorizes a payment for the provided amount. Provide at least one identifier for locations. This method accept */
  authorizePayment: AuthorizedPayment;
  /** Authorizes a payment for the provided amount. Provide at least one identifier for locations. This method accept */
  authorizePaymentV2: AuthorizePaymentResult;
  /** Cancels an incomplete bill payment initialized using createBillPayment. */
  cancelBillPayment: StandardMutationResult;
  /** Cancels an incomplete order initialized using createOrder. */
  cancelOrder: StandardMutationResult;
  /** Cancel a previously started (but not completed) promotion redemption */
  cancelPromotionRedemption: StandardMutationResult;
  /** Cancel an existing Stripe setup intent if no longer required */
  cancelSetupIntent: StandardMutationResult;
  /**
   * Check in to a location using the specified payment method, optionally specify a limit (if required for this location)
   * @deprecated Replaced by checkInToV2
   */
  checkInTo: CheckIn;
  /** Check in to a location using the specified payment method, optionally specify a limit (if required for this location) */
  checkInToV2: CheckInResult;
  /** DEPRECATED. Check out of the location. */
  checkOutOf: CheckOutResultV1;
  /** Check out of the location */
  checkOutOfV2: CheckOutResult;
  /** Claims an inventory item that was a reward of a promotion. */
  claimItem: ClaimItemResult;
  /** Single mutation to start and finish promotion redemption. Don't use with paid promotions */
  claimPromotion: ClaimPromotionResult;
  completeBillPayment: TableBillMutationResult;
  /** Completes an order initialized using createOrder. */
  completeOrder: CompleteOrderResult;
  /** Complete the customer promotion (incl. payment) */
  completePromotionRedemption: StandardMutationResult;
  /** Confirm an existing Stripe setup intent has been completed */
  confirmSetupIntent: PaymentMethodResult;
  createBillPayment: CreateBillPaymentResult;
  createCart: CreateCartResult;
  /** Starts a session for an order. If no payment method is provided the user will have to attach it to the session later. */
  createOrder: CreateOrderResult;
  createOrderFromCart: CreateOrderResult;
  /** Create a new Stripe setup intent to save a payment method */
  createSetupIntent: SetupIntentResult;
  /** Requests for the authenticated user's profile to be deleted */
  deleteProfile: MessageMutationResult;
  /** Pushes an order ahead order to the terminal. NOTE: total is the expected total. An error will occur if this does not match. NOTE2: a nonce for a payment must be provided - see authorizePaymentV2 to get this. */
  placeOrder: StandardMutationResult;
  /** DEPRECATED. Adds a new payment method */
  rateLocation: Scalars["Boolean"]["output"];
  /** Adds a new payment method */
  rateLocationV2: StandardMutationResult;
  /** redeem voucher Code */
  redeemCode: RedeemCodeResult;
  /** DEPRECATED. Adds a new payment method */
  removePaymentMethod: Scalars["Boolean"]["output"];
  /** Adds a new payment method */
  removePaymentMethodV2: StandardMutationResult;
  /** Send verification code to mobile number via sms */
  requestPhoneNumberVerification: StandardMutationResult;
  /** Starts the promotion redemption flow for paid promotions */
  startPromotionRedemption: StartPromotionRedemptionResult;
  /** Submit app review with score and optional metadata */
  submitAppReview: StandardMutationResult;
  /** Submit upsell suggestion request */
  submitUpsellSuggestion: SubmitUpsellSuggestionResult;
  /** Updates the tip amount on a bill */
  updateBillTip: StandardMutationResult;
  /** DEPRECATED. Updates the payment method used for this location */
  updateCheckIn: CheckIn;
  /** Updates the payment method used for this location */
  updateCheckInV2: CheckInResult;
  /** Updates the tip amount on an order */
  updateOrderTip: StandardMutationResult;
  /** Verify phone number based on code send via sms */
  verifyPhoneNumber: StandardMutationResult;
};

export type MutationAddPaymentMethodArgs = {
  details: PaymentMethodInput;
};

export type MutationAddPaymentMethodV2Args = {
  details: PaymentMethodInput;
};

export type MutationAddWalletArgs = {
  details: AddWalletInput;
};

export type MutationAssociatePaymentMethodArgs = {
  token: Scalars["String"]["input"];
};

export type MutationAuthorizePaymentArgs = {
  cardId: Scalars["String"]["input"];
  order: JsInterfaceOrder;
};

export type MutationAuthorizePaymentV2Args = {
  cardId: Scalars["String"]["input"];
  order: JsInterfaceOrder;
};

export type MutationCancelBillPaymentArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCancelOrderArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCancelPromotionRedemptionArgs = {
  orderId: Scalars["String"]["input"];
};

export type MutationCancelSetupIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCheckInToArgs = {
  autoCheckOut?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationCheckInToV2Args = {
  autoCheckOut?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationCheckOutOfArgs = {
  location: Scalars["String"]["input"];
};

export type MutationCheckOutOfV2Args = {
  location: Scalars["String"]["input"];
};

export type MutationClaimItemArgs = {
  inventoryItemId: Scalars["String"]["input"];
  locationId: Scalars["String"]["input"];
};

export type MutationClaimPromotionArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  promotionId: Scalars["String"]["input"];
};

export type MutationCompleteBillPaymentArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCompleteOrderArgs = {
  externalPayment?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["String"]["input"];
};

export type MutationCompletePromotionRedemptionArgs = {
  locationId: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
};

export type MutationConfirmSetupIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCreateBillPaymentArgs = {
  amount: Scalars["Int"]["input"];
  billId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  location: Scalars["String"]["input"];
  tip?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateCartArgs = {
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  fulfillmentType: FulfillmentType;
  id: Scalars["String"]["input"];
  items: Array<CartItemInput>;
  location: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  serviceRef?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  timeSlot?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateOrderArgs = {
  customerOverride?: InputMaybe<OrderCustomerOverride>;
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  items: Array<OrderAheadItem>;
  location: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
  ref?: InputMaybe<Scalars["String"]["input"]>;
  serviceRef?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  timeSlot?: InputMaybe<Scalars["String"]["input"]>;
  tip?: InputMaybe<Scalars["Int"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type MutationCreateOrderFromCartArgs = {
  cartId: Scalars["String"]["input"];
  customerOverride?: InputMaybe<OrderCustomerOverride>;
  location: Scalars["String"]["input"];
  tip?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationPlaceOrderArgs = {
  cardId: Scalars["String"]["input"];
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  items: Array<OrderAheadItem>;
  location: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  table?: InputMaybe<Scalars["String"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type MutationRateLocationArgs = {
  location: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
};

export type MutationRateLocationV2Args = {
  location: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
};

export type MutationRedeemCodeArgs = {
  code: Scalars["String"]["input"];
};

export type MutationRemovePaymentMethodArgs = {
  paymentMethod: Scalars["String"]["input"];
};

export type MutationRemovePaymentMethodV2Args = {
  paymentMethod: Scalars["String"]["input"];
};

export type MutationRequestPhoneNumberVerificationArgs = {
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStartPromotionRedemptionArgs = {
  locationId: Scalars["String"]["input"];
  promotionId: Scalars["String"]["input"];
};

export type MutationSubmitAppReviewArgs = {
  appPlatform?: InputMaybe<Scalars["String"]["input"]>;
  appVersion?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  score: AppScore;
};

export type MutationSubmitUpsellSuggestionArgs = {
  cart: UpsellCartInput;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  location: Scalars["String"]["input"];
};

export type MutationUpdateBillTipArgs = {
  id: Scalars["String"]["input"];
  tip: Scalars["Int"]["input"];
};

export type MutationUpdateCheckInArgs = {
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationUpdateCheckInV2Args = {
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationUpdateOrderTipArgs = {
  id: Scalars["String"]["input"];
  tip: Scalars["Int"]["input"];
};

export type MutationVerifyPhoneNumberArgs = {
  verificationCode: Scalars["String"]["input"];
};

/** Represents an application level error while executing a mutation */
export type MutationError = {
  __typename?: "MutationError";
  /** Optional identifier of the error type for triggering custom behavior */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The message for an error */
  message: Scalars["String"]["output"];
};

/** Mutation result with flag indicating success, and an error message in the event of failure */
export type MutationResult = {
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

export type OptionChoiceDef = {
  __typename?: "OptionChoiceDef";
  defaultQuantity: Scalars["Int"]["output"];
  maxQuantity: Scalars["Int"]["output"];
  minQuantity: Scalars["Int"]["output"];
  productDef: ProductDef;
};

export type OptionChoiceV2 = {
  __typename?: "OptionChoiceV2";
  defaultQuantity: Scalars["Int"]["output"];
  maxQuantity: Scalars["Int"]["output"];
  minQuantity: Scalars["Int"]["output"];
  product: ProductV2;
};

export type Order = {
  __typename?: "Order";
  billingType?: Maybe<Scalars["String"]["output"]>;
  created: Scalars["Date"]["output"];
  creditAmount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  customerFeeAmount: Scalars["Int"]["output"];
  deliveryAddress?: Maybe<AddressDelivery>;
  /** @deprecated We should move away from this approach, Activity should be about the past not the future. Details on live orders can be handled separately. */
  deliveryAtMax?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated We should move away from this approach, Activity should be about the past not the future. Details on live orders can be handled separately. */
  deliveryAtMin?: Maybe<Scalars["Date"]["output"]>;
  discounts?: Maybe<Array<Maybe<OrderModifier>>>;
  estimatedReadyAt?: Maybe<Scalars["Date"]["output"]>;
  event: PosEvent;
  externalAmount: Scalars["Int"]["output"];
  fulfillAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  itemTax?: Maybe<Scalars["Int"]["output"]>;
  itemTotal: Scalars["Int"]["output"];
  items: Array<OrderItem>;
  location?: Maybe<Location>;
  modifiers?: Maybe<Array<Maybe<OrderModifier>>>;
  orderAcceptedAt?: Maybe<Scalars["Date"]["output"]>;
  paymentId?: Maybe<Scalars["String"]["output"]>;
  paymentMethodIconUrl?: Maybe<Scalars["String"]["output"]>;
  paymentMethodName?: Maybe<Scalars["String"]["output"]>;
  paymentMethodType?: Maybe<Scalars["String"]["output"]>;
  points?: Maybe<Scalars["Int"]["output"]>;
  refId: Scalars["String"]["output"];
  serviceRef?: Maybe<Scalars["String"]["output"]>;
  tax?: Maybe<Scalars["Int"]["output"]>;
  tipAmount?: Maybe<Scalars["Int"]["output"]>;
  total: Scalars["Int"]["output"];
};

export type OrderAdjustment = {
  amount: Scalars["Int"]["input"];
  id: Scalars["String"]["input"];
  itemsAffected?: InputMaybe<Array<ItemAffectedRef>>;
  label: Scalars["String"]["input"];
  taxIncluded?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrderAheadChoice = {
  /** The ID of the selected choice */
  id: Scalars["String"]["input"];
  /** Option choices for this item. Set to null if no options. */
  options?: InputMaybe<Array<OrderAheadOption>>;
  /** Number of these items to order */
  quantity?: InputMaybe<Scalars["Int"]["input"]>;
  /** If a choice is unavailable */
  unavailable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a single item to be ordered */
export type OrderAheadItem = {
  /** The ID of the item to be ordered */
  id: Scalars["String"]["input"];
  /** Whether the item is a deal or a product. Absent means product */
  itemType?: InputMaybe<CartItemType>;
  /** Optionally specify a note for the product */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Option choices for this item. Set to null if no options. */
  options?: InputMaybe<Array<OrderAheadOption>>;
  /** Number of these items to order */
  quantity: Scalars["Int"]["input"];
  /** If an item is unavailable */
  unavailable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrderAheadOption = {
  /** List of selected choices */
  choices: Array<OrderAheadChoice>;
  /** The ID of the option being set */
  id: Scalars["String"]["input"];
};

export type OrderCard = Card & {
  __typename?: "OrderCard";
  /** Unused */
  action?: Maybe<Action>;
  /** The status of this order as a string. */
  badgeText?: Maybe<Scalars["String"]["output"]>;
  /** Unused */
  details?: Maybe<Scalars["String"]["output"]>;
  /** ORDER */
  displayType?: Maybe<CardDisplayType>;
  estimatedReadyAt?: Maybe<Scalars["Date"]["output"]>;
  fulfillAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  /**
   * Unused
   * Width and height will be applied if possible via image resizer.
   */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  infoText?: Maybe<Scalars["String"]["output"]>;
  /** Location name */
  locationName: Scalars["String"]["output"];
  /** Current state of this order. */
  state: OrderState;
  /** Time this order was created. */
  timestamp: Scalars["Date"]["output"];
  /** The order number. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Total cost of this order formatted. */
  totalFormatted: Scalars["String"]["output"];
};

export type OrderCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrderChoice = {
  __typename?: "OrderChoice";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderCustomerOverride = {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
};

/** Delivery details for ordering */
export type OrderDeliveryConfig = {
  __typename?: "OrderDeliveryConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** External payment limit (ie: max. cash transaction allowed) */
  externalPaymentLimit?: Maybe<Scalars["Int"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * DEPRECATED. Cost of delivery in cents
   * @deprecated Use feePrice
   */
  feeAmount: Scalars["Int"]["output"];
  feePrice?: Maybe<Price>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum order amount for delivery in cents */
  minimumAmount: Scalars["Int"]["output"];
  /** Estimated max delivery time in minutes */
  minutesMax: Scalars["Int"]["output"];
  /** Estimated min delivery time in minutes */
  minutesMin: Scalars["Int"]["output"];
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** A list of post codes that can be delivered too */
  postcodes: Array<Scalars["String"]["output"]>;
  /** Timeslots for showing times */
  timeSlots?: Maybe<Array<TimeSlot>>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
};

export type OrderItem = {
  __typename?: "OrderItem";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  options?: Maybe<Array<Maybe<OrderOption>>>;
  quantity: Scalars["Int"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderModifier = {
  __typename?: "OrderModifier";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderOption = {
  __typename?: "OrderOption";
  choices: Array<Maybe<OrderChoice>>;
  name: Scalars["String"]["output"];
};

/** Pickup details for ordering */
export type OrderPickupConfig = {
  __typename?: "OrderPickupConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** External payment limit (ie: max. cash transaction allowed) */
  externalPaymentLimit?: Maybe<Scalars["Int"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Timeslots for showing times */
  timeSlots?: Maybe<Array<TimeSlot>>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
  /** Estimated wait time for new orders in minutes. */
  waitTime: Scalars["Int"]["output"];
};

/** "At table/room/etc" details for ordering */
export type OrderServiceConfig = {
  __typename?: "OrderServiceConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** External payment limit (ie: max. cash transaction allowed) */
  externalPaymentLimit?: Maybe<Scalars["Int"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Service charge Label */
  serviceChargeLabel?: Maybe<Scalars["String"]["output"]>;
  /** Service charge rate, ie: 0.10 is 10%, do not show a service charge when 0 */
  serviceChargeRate?: Maybe<Scalars["Float"]["output"]>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
  /** A list of valid refs, typically table numbers for "order at table". No verification should take place if null. */
  validRefs?: Maybe<Array<OrderServiceRef>>;
  /** Estimated wait time for new orders in minutes. */
  waitTime: Scalars["Int"]["output"];
};

/** Represent a service reference such as a table number, room number, etc */
export type OrderServiceRef = {
  __typename?: "OrderServiceRef";
  /** Ref ID */
  ref: Scalars["String"]["output"];
};

export type OrderSession = {
  __typename?: "OrderSession";
  /** Amount of total allocated to credit */
  creditAmount: Scalars["Int"]["output"];
  /** Order currency code */
  currency: Scalars["String"]["output"];
  /** Amount of total allocated to discount */
  discountAmount: Scalars["Int"]["output"];
  /** The (session) order ID */
  id: Scalars["String"]["output"];
  /** Amount of total allocated to payment */
  paymentAmount: Scalars["Int"]["output"];
  /** Client secret of the Stripe payment intent for Stripe elements. Will be null if no payment amount. */
  paymentIntentSecret?: Maybe<Scalars["String"]["output"]>;
  /** External URL to forward the customer to, to complete the payment */
  portalUrl?: Maybe<Scalars["String"]["output"]>;
  /** If the order requires phone verification before being completed */
  requirePhoneVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** Array of label and value pairs */
  summaryItems: Array<SummaryItem>;
  /** Amount of the tip for the order. NOTE: this is provided in summaryItems too */
  tipAmount: Scalars["Int"]["output"];
  /** signed token for accessing this order from a guest session */
  token?: Maybe<Scalars["String"]["output"]>;
};

export enum OrderState {
  /** The order could not be created, or was rejected */
  Failed = "FAILED",
  /** The order has been accepted, is being made, delivered, or anything in between NEW and SUCCESS */
  InProgress = "IN_PROGRESS",
  /** The order has been created, but has not yet been reviewed / accepted / rejected */
  New = "NEW",
  /** The order has been accepted and is being, or has been processed */
  Success = "SUCCESS",
}

/** Ordering data for a location */
export type Ordering = {
  __typename?: "Ordering";
  /**
   * Details for delivery (if available, else null)
   * @deprecated Use deliveryConfig
   */
  delivery?: Maybe<OrderDeliveryConfig>;
  deliveryAddressStatus?: Maybe<DeliveryAddressStatus>;
  /** Details for delivery (if available, else null) */
  deliveryConfig?: Maybe<OrderDeliveryConfig>;
  /** Order ahead product menu. Note: returns null if no menu available for this location. */
  menu?: Maybe<Array<ProductCategory>>;
  menuV2?: Maybe<MenuV2>;
  menus?: Maybe<Array<MenuV2>>;
  /** Details for pickup (if available, else null) */
  pickupConfig?: Maybe<OrderPickupConfig>;
  product?: Maybe<ProductV2>;
  /** Returns the most recent (accepted) carts for a customer at a location */
  recentCarts: Array<Cart>;
  /** Details for service ordering (table service, room service) (if available, else null) */
  serviceConfig?: Maybe<OrderServiceConfig>;
  /**
   * A list of valid table numbers for "order at table". Returns null if table numbers or order-at-table is not configured. No table verification should take place if null.
   * @deprecated Use validRefs specified under serviceConfig
   */
  tables?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Estimated wait time for new orders in minutes.
   * @deprecated Use times specified under delivery/pickup/ref
   */
  waitTime: Scalars["Int"]["output"];
};

/** Ordering data for a location */
export type OrderingDeliveryAddressStatusArgs = {
  address?: InputMaybe<DeliveryAddress>;
};

/** Ordering data for a location */
export type OrderingDeliveryConfigArgs = {
  to?: InputMaybe<CoordsInput>;
};

/** Ordering data for a location */
export type OrderingMenuArgs = {
  fulfillmentType?: InputMaybe<FulfillmentType>;
  selectedTimeSlot?: InputMaybe<Scalars["String"]["input"]>;
};

/** Ordering data for a location */
export type OrderingMenuV2Args = {
  menuId: Scalars["String"]["input"];
};

/** Ordering data for a location */
export type OrderingMenusArgs = {
  fulfillmentType?: InputMaybe<FulfillmentType>;
};

/** Ordering data for a location */
export type OrderingProductArgs = {
  plu?: InputMaybe<Scalars["String"]["input"]>;
  productId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Ordering data for a location */
export type OrderingRecentCartsArgs = {
  limit: Scalars["Int"]["input"];
};

export type OrderingPaymentOption = PaymentOption & {
  __typename?: "OrderingPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** ie: I'm collecting from */
  locationConfirmText?: Maybe<Scalars["String"]["output"]>;
  /** if null do not prompt for a ref (table/room number) */
  refPromptText?: Maybe<Scalars["String"]["output"]>;
  scanner: ScannerBehaviour;
  scannerTitle?: Maybe<Scalars["String"]["output"]>;
  waitTimeText?: Maybe<Scalars["String"]["output"]>;
};

export enum OrderingStatus {
  /** The store is currently offline and NOT accepting orders */
  Offline = "OFFLINE",
  /** The store is currently online and accepting orders */
  Online = "ONLINE",
}

/** Fee configuration for the session's organization. */
export type OrganizationFees = {
  __typename?: "OrganizationFees";
  /** Fees charged to the customer on top of the order amount. */
  customerFees: CustomerFees;
  /** When true, no customer fee is applied to the tip portion. */
  noCustomerFeeOnTip: Scalars["Boolean"]["output"];
};

/** Standardised pagination */
export type PageInfo = {
  __typename?: "PageInfo";
  endCursor: Scalars["String"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor: Scalars["String"]["output"];
};

export type Payment = {
  __typename?: "Payment";
  billingType?: Maybe<Scalars["String"]["output"]>;
  locationUid: Scalars["String"]["output"];
  orderSession?: Maybe<OrderSession>;
  receipt: PaymentReceipt;
  state: PaymentState;
};

/** Defines an action to take to load a spend option for a location. */
export enum PaymentAction {
  /** Check-in based in store payments. */
  CheckIn = "CHECK_IN",
  /** Order, pay and get it delivered! #COVID-19 */
  Delivery = "DELIVERY",
  /** Order ahead payments. */
  OrderAhead = "ORDER_AHEAD",
  /** Order at table payments. */
  OrderAtTable = "ORDER_AT_TABLE",
  /** Pay at table (or at terminal) payments. */
  PayAtTable = "PAY_AT_TABLE",
}

export type PaymentActivityEvent = {
  __typename?: "PaymentActivityEvent";
  message: Scalars["String"]["output"];
  tone: Tone;
};

export type PaymentActivityResult = {
  __typename?: "PaymentActivityResult";
  items: Array<Activity>;
  pageInfo: PageInfo;
  summary: ActivitySummary;
};

export type PaymentMethod = {
  __typename?: "PaymentMethod";
  /** Raw card brand from Stripe (e.g. "visa", "mastercard"). */
  brand?: Maybe<Scalars["String"]["output"]>;
  /** Display string for this payment method. */
  displayText: Scalars["String"]["output"];
  /** DEPRECATED Expiry can also be retrieved as a timestamp, null for non credit card types. */
  expires?: Maybe<Scalars["Date"]["output"]>;
  /** DEPRECATED Expiry is only available for credit cards, null for other types. */
  expiry: Scalars["String"]["output"];
  /** Icon URL to display for the payment method. */
  iconUrl: Scalars["String"]["output"];
  /** The unique ID of this payment method. */
  id: Scalars["String"]["output"];
  /** Identifier display string for this payment method. */
  idText: Scalars["String"]["output"];
  /** True if the card has expired (last day of the expiry month is in the past). */
  isExpired: Scalars["Boolean"]["output"];
  /** Last 4 digits of the card number. */
  last4?: Maybe<Scalars["String"]["output"]>;
  /** DEPRECATED The display name for this payment method. */
  name: Scalars["String"]["output"];
  /** Surcharge rate (fee) that will apply to payments using this method. 0 if no surcharge. */
  surcharge: Scalars["Float"]["output"];
  /** DEPRECATED Payment method or credit card type (NOTE: maybe this should be an enum?). */
  type: Scalars["String"]["output"];
  /** Type display string for this payment method. */
  typeText: Scalars["String"]["output"];
  /** Wallet type the payment method belongs to ( dbs/ paylah / masterpass / null ). */
  walletType?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentMethodInput = {
  /** Braintree */
  nonce?: InputMaybe<Scalars["String"]["input"]>;
  /** DBS */
  requestId?: InputMaybe<Scalars["String"]["input"]>;
  /** FatZebra, Masterpass, Stripe */
  token?: InputMaybe<Scalars["String"]["input"]>;
  /** Cardstream */
  xref?: InputMaybe<Scalars["String"]["input"]>;
};

/** Payment method result extends a mutation result, but also provides the payment method in the event of success */
export type PaymentMethodResult = MutationResult & {
  __typename?: "PaymentMethodResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method data */
  paymentMethod?: Maybe<PaymentMethod>;
};

/** A spend option for a location defined a spend action available at a location. */
export type PaymentOption = {
  /**
   * Defines the actionable method to use for this spend option.
   * @deprecated logic should now be inferred from the type (__typename)
   */
  action: PaymentAction;
  id: Scalars["String"]["output"];
  /** Label for the action (to be used on buttons etc). */
  label: Scalars["String"]["output"];
};

export type PaymentPromotionActivity = Activity & {
  __typename?: "PaymentPromotionActivity";
  credit?: Maybe<Credit>;
  id: Scalars["String"]["output"];
  item?: Maybe<Item>;
  locationName?: Maybe<Scalars["String"]["output"]>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars["String"]["output"]>;
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  promotion: Promotion;
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

export type PaymentReceipt = {
  __typename?: "PaymentReceipt";
  details: Receipt;
  state: PaymentState;
  timeline: Array<PaymentTimelineEntry>;
};

export type PaymentSpendActivity = Activity & {
  __typename?: "PaymentSpendActivity";
  cart?: Maybe<Cart>;
  event: PaymentActivityEvent;
  id: Scalars["String"]["output"];
  locationName?: Maybe<Scalars["String"]["output"]>;
  payment: Payment;
  paymentId: Scalars["String"]["output"];
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

/**
 * PaymentState is the same as OrdersV3.OrderState
 * This is not called OrderState because we already have that
 */
export enum PaymentState {
  Authorized = "authorized",
  Canceled = "canceled",
  Created = "created",
  Disputed = "disputed",
  Failed = "failed",
  PartiallyRefunded = "partially_refunded",
  Refunded = "refunded",
  Settled = "settled",
  Submitted = "submitted",
}

export type PaymentTimelineEntry = {
  __typename?: "PaymentTimelineEntry";
  label: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

/** Metadata about a payment gateway */
export type PaymentsMetadata = {
  /** Display name for the gateway */
  name: Scalars["String"]["output"];
  /** Gateway type */
  type: PaymentsType;
};

/** The gateway type for payments */
export enum PaymentsType {
  /** Braintree using the v.zero drop in UI */
  BraintreeVzero = "BRAINTREE_VZERO",
  /** Cardstream (UK payment gateway) */
  Cardstream = "CARDSTREAM",
  /** DBS: credit cards and PayLah */
  Dbs = "DBS",
  /** DBS: credit cards only (wirecard) */
  DbsCard = "DBS_CARD",
  /** FatZebra using credit cards only */
  FatzebraCard = "FATZEBRA_CARD",
  /** FatZebra using both credit cards and Masterpass */
  FatzebraCardMasterpass = "FATZEBRA_CARD_MASTERPASS",
  /** FatZebra using Masterpass only */
  FatzebraMasterpass = "FATZEBRA_MASTERPASS",
  /** Stripe (legacy Stripe integration) */
  Stripe = "STRIPE",
  /** Stripe Connect */
  StripeConnect = "STRIPE_CONNECT",
}

export type Period = {
  __typename?: "Period";
  dayOfTheWeek: DayOfTheWeek;
  end: Scalars["String"]["output"];
  start: Scalars["String"]["output"];
};

export type PlaceLocation = {
  __typename?: "PlaceLocation";
  formattedAddress: Scalars["String"]["output"];
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
};

export type PointsActivity = Activity & {
  __typename?: "PointsActivity";
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Location is always null */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Points adjusted */
  points: Scalars["Int"]["output"];
  /** Formatted version of points adjusted */
  pointsText: Scalars["String"]["output"];
  /** Adjustment time */
  timestamp: Scalars["Date"]["output"];
  /** Comment for adjustment */
  title: Scalars["String"]["output"];
};

export type PosEvent = {
  __typename?: "PosEvent";
  message: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
  tone: Tone;
};

export type Price = {
  __typename?: "Price";
  amount: Scalars["Int"]["output"];
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
};

export type PriorityMessage = {
  __typename?: "PriorityMessage";
  body: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  flags: Array<Scalars["String"]["output"]>;
  header: Scalars["String"]["output"];
  isGlobal: Scalars["Boolean"]["output"];
  messageId: Scalars["String"]["output"];
  source: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Represents a category of products available to order. */
export type ProductCategory = {
  __typename?: "ProductCategory";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  products: Array<MenuProductItem>;
};

export type ProductCategoryV2 = {
  __typename?: "ProductCategoryV2";
  id: Scalars["String"]["output"];
  /** Optionally restrict resulting products to the provided IDs to reduce response payload size */
  products?: Maybe<Array<ProductV2>>;
  title: Scalars["String"]["output"];
};

export type ProductCategoryV2ProductsArgs = {
  productIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ProductChoice = {
  __typename?: "ProductChoice";
  amount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** True if this choice should be selected by default. */
  selected: Scalars["Boolean"]["output"];
};

export type ProductDef = {
  __typename?: "ProductDef";
  id: Scalars["String"]["output"];
  options?: Maybe<Array<ProductOptionDef>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ProductItem = {
  amount: Scalars["Int"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** may differ from the standard product amount */
  displayAmount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  options?: Maybe<Array<Maybe<ProductOption>>>;
  tags: Array<Scalars["String"]["output"]>;
};

export type ProductOption = {
  __typename?: "ProductOption";
  choices: Array<ProductChoice>;
  id: Scalars["String"]["output"];
  maxSelect?: Maybe<Scalars["Int"]["output"]>;
  minSelect: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type ProductOptionDef = {
  __typename?: "ProductOptionDef";
  choices?: Maybe<Array<OptionChoiceDef>>;
  id: Scalars["String"]["output"];
  maxQuantity?: Maybe<Scalars["Int"]["output"]>;
  minQuantity: Scalars["Int"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ProductOptionV2 = {
  __typename?: "ProductOptionV2";
  choices: Array<OptionChoiceV2>;
  id: Scalars["String"]["output"];
  maxQuantity?: Maybe<Scalars["Int"]["output"]>;
  minQuantity: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type ProductV2 = {
  __typename?: "ProductV2";
  available: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  options: Array<ProductOptionV2>;
  plu?: Maybe<Scalars["String"]["output"]>;
  price: Price;
  tags: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  visibility?: Maybe<Array<Period>>;
};

export type ProfileItem = {
  __typename?: "ProfileItem";
  dataType?: Maybe<ProfileItemDataType>;
  field?: Maybe<Scalars["String"]["output"]>;
  formattedLabel?: Maybe<Scalars["String"]["output"]>;
  inputType?: Maybe<InputType>;
  keyboardType?: Maybe<KeyboardType>;
  label?: Maybe<Scalars["String"]["output"]>;
  maxLength?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  options?: Maybe<Array<ProfileItemOption>>;
  required?: Maybe<Scalars["Boolean"]["output"]>;
  type?: Maybe<ProfileItemType>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum ProfileItemDataType {
  Boolean = "BOOLEAN",
  Date = "DATE",
  Integer = "INTEGER",
  String = "STRING",
}

export type ProfileItemOption = {
  __typename?: "ProfileItemOption";
  label?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum ProfileItemType {
  Barcode = "BARCODE",
  BirthDate = "BIRTH_DATE",
  Date = "DATE",
  Datetime = "DATETIME",
  Default = "DEFAULT",
  Divider = "DIVIDER",
  Email = "EMAIL",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
  Legal = "LEGAL",
  /** Store / site / location */
  Location = "LOCATION",
  Options = "OPTIONS",
  Password = "PASSWORD",
  Phone = "PHONE",
  Points = "POINTS",
  Postcode = "POSTCODE",
  PrimaryEmail = "PRIMARY_EMAIL",
  PrimaryPhone = "PRIMARY_PHONE",
  Terms = "TERMS",
  Tick = "TICK",
}

export enum ProfileScope {
  Create = "CREATE",
  Read = "READ",
  Update = "UPDATE",
}

/** Promotion */
export type Promotion = {
  __typename?: "Promotion";
  details: Scalars["String"]["output"];
  price?: Maybe<Scalars["Int"]["output"]>;
  priceType?: Maybe<PromotionPriceType>;
  title: Scalars["String"]["output"];
};

export type PromotionActivity = Activity & {
  __typename?: "PromotionActivity";
  /** Credit received if any */
  credit?: Maybe<Credit>;
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Item received if any */
  item?: Maybe<Item>;
  /** Location is always null for now */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Related order if there was one */
  order?: Maybe<Order>;
  /** Points received (spend or gift or both) */
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  /** Promotion */
  promotion: Promotion;
  /** Promotion redemption time */
  timestamp: Scalars["Date"]["output"];
  /** Promotion event title */
  title: Scalars["String"]["output"];
};

export enum PromotionDisplayType {
  ImageOnly = "IMAGE_ONLY",
  ImageWithDescription = "IMAGE_WITH_DESCRIPTION",
  NoImage = "NO_IMAGE",
}

export type PromotionLocation = {
  __typename?: "PromotionLocation";
  id: Scalars["String"]["output"];
};

export enum PromotionPriceType {
  Dollars = "DOLLARS",
  None = "NONE",
  Points = "POINTS",
}

export enum PromotionRewardType {
  Credit = "CREDIT",
  Discount = "DISCOUNT",
  Item = "ITEM",
  List = "LIST",
  Points = "POINTS",
  Webhook = "WEBHOOK",
}

export enum PromotionType {
  Code = "CODE",
  Gift = "GIFT",
  Info = "INFO",
  Spend = "SPEND",
  Web = "WEB",
}

export type QrCode = {
  __typename?: "QRCode";
  content: Scalars["String"]["output"];
  image: Scalars["String"]["output"];
};

export type Query = {
  __typename?: "Query";
  /** All activity for the logged on user - messages (broadcast), spend, redemptions, collections. */
  activity: ActivityResult;
  /** Address lookup, returns null of no matching address found */
  address: Array<AddressDetails>;
  /**
   * Address auto complete, returns name and ref
   * It is intended that locationRef will become mandatory in the future once all implementations are sending the locationRef
   */
  addressAutocomplete: Array<AddressAutocomplete>;
  /** Resolves auto complete ref to AddressDetails */
  addressDetails: AddressDetailsResponse;
  /**
   * formatted balances
   * @deprecated To support multiple discounts in the future, use discounts.
   */
  balance: Balance;
  /** Return table bill for this customer if available. Return null if no available table bill for this location's table number. */
  bill?: Maybe<TableBill>;
  billPaymentConfig?: Maybe<BillPaymentConfig>;
  /** List of card details for the home screen (accessible without access token). */
  cards?: Maybe<Array<Card>>;
  /** Gets check in details if available currently at this location (ie: in-store payments check in). Will return empty array if no/null location. */
  checkIn?: Maybe<CheckIn>;
  /** Preview details for a code (name, description, reward type) without redeeming it. */
  codePreview?: Maybe<CodePreview>;
  /** discount */
  discount?: Maybe<Discount>;
  /** discounts */
  discounts?: Maybe<Array<Discount>>;
  /** If this returns null keep routing to the internal app url */
  embeddedUrl?: Maybe<Scalars["String"]["output"]>;
  /** Feature flags */
  features: Array<FeatureFlag>;
  findPlace?: Maybe<PlaceLocation>;
  /** legals */
  legals?: Maybe<Array<LegalItem>>;
  location?: Maybe<Location>;
  locationDeals: Array<LocationDeal>;
  /** Locations/stores/sites for this merchant, optionally sorted by distance to myLocation. */
  locations?: Maybe<Array<Location>>;
  /** Returns details about me - the currently logged on user. */
  me?: Maybe<Customer>;
  /**
   * DEPRECATED. Use menuItems.
   * @deprecated Use menuItems
   */
  menu?: Maybe<Array<MenuItem>>;
  /** Items to be listed for the side menu (accessible without access token). Note this will change when a user's state changes. */
  menuItems: Array<MenuItem>;
  /** Returns information about the merchant associated with this user or application key (accessible without access token). */
  merchant: Merchant;
  /**
   * DEPRECATED Messages (from Broadcast) sent to this user.
   * @deprecated Use activity
   */
  messages: Array<Message>;
  order?: Maybe<Order>;
  /** Ordering data such as wait time, product menu, table numbers and bills. Note: returns null if not enabled for this location. */
  ordering?: Maybe<Ordering>;
  /** Payment processing fees charged to the customer, for this merchant. Scoped to the session's organization. */
  organizationFees?: Maybe<OrganizationFees>;
  payment?: Maybe<Payment>;
  paymentActivity: PaymentActivityResult;
  priorityMessages: Array<PriorityMessage>;
  /** Profile fields available to for sign up, profile view, and profile edit. */
  profileFields?: Maybe<Array<ProfileItem>>;
  /** List of promotion details for web promotions tab screen */
  promotions?: Maybe<Array<WebPromotion>>;
  /** Returns true if the user should be prompted to review the app (3 or more completed orders) */
  promptAppReview: Scalars["Boolean"]["output"];
  /** Resolves single reward based on id (eg 1234:RewardCredit) */
  reward?: Maybe<Reward>;
  /** Resolves rewards available for customer */
  rewards?: Maybe<RewardResult>;
  /** Returns information about the session for this user. */
  session?: Maybe<Session>;
  /**
   * DEPRECATED Returns spend history for this customer if available. Returns null if this customer does not have payments. Specify transactionId to filter for a specific transaction. Will return empty array if no matched transaction.
   * @deprecated Use activity
   */
  spendHistory: Array<SpendHistoryItem>;
  /**
   * Gets the spend options available at the selected location (eg in-store and order ahead).
   * @deprecated Use merchant->location->paymentOptions instead
   */
  spendOptions: Array<SpendOption>;
  /** Returns formatted strings for various in app uses. */
  strings?: Maybe<Strings>;
  /** Get upsell suggestions by request ID */
  upsellSuggestions?: Maybe<UpsellSuggestion>;
  webLinks: Array<WebLink>;
};

export type QueryActivityArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAddressArgs = {
  query: Scalars["String"]["input"];
};

export type QueryAddressAutocompleteArgs = {
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
  query: Scalars["String"]["input"];
  sessionToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAddressDetailsArgs = {
  ref: Scalars["String"]["input"];
  sessionToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBalanceArgs = {
  location: Scalars["String"]["input"];
};

export type QueryBillArgs = {
  billId?: InputMaybe<Scalars["String"]["input"]>;
  location: Scalars["String"]["input"];
  ref?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBillPaymentConfigArgs = {
  location: Scalars["String"]["input"];
};

export type QueryCardsArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCheckInArgs = {
  byId?: InputMaybe<CheckInByIdInput>;
  location?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCodePreviewArgs = {
  code: Scalars["String"]["input"];
};

export type QueryDiscountArgs = {
  location: Scalars["String"]["input"];
};

export type QueryDiscountsArgs = {
  adjustments?: InputMaybe<Array<OrderAdjustment>>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  items?: InputMaybe<Array<OrderAheadItem>>;
  location: Scalars["String"]["input"];
  selectedTimeSlot?: InputMaybe<Scalars["String"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type QueryEmbeddedUrlArgs = {
  appUrl: Scalars["String"]["input"];
};

export type QueryFeaturesArgs = {
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  keys: Array<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFindPlaceArgs = {
  query: Scalars["String"]["input"];
};

export type QueryLocationArgs = {
  locationRef: Scalars["String"]["input"];
};

export type QueryLocationDealsArgs = {
  locationRef: Scalars["String"]["input"];
};

export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  myLocation?: InputMaybe<CoordsInput>;
  nativeOrderingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMessagesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryOrderArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryOrderingArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPaymentArgs = {
  paymentId: Scalars["String"]["input"];
};

export type QueryPaymentActivityArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryPriorityMessagesArgs = {
  locationRef: Scalars["String"]["input"];
};

export type QueryProfileFieldsArgs = {
  scope: ProfileScope;
};

export type QueryPromotionsArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPromptAppReviewArgs = {
  appPlatform?: InputMaybe<Scalars["String"]["input"]>;
  appVersion?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRewardArgs = {
  id: Scalars["String"]["input"];
};

export type QueryRewardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpendHistoryArgs = {
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  transactionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpendOptionsArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
  supportedActions?: InputMaybe<Array<SpendAction>>;
};

export type QueryUpsellSuggestionsArgs = {
  requestId: Scalars["String"]["input"];
};

export type QueryWebLinksArgs = {
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

export type Receipt = {
  __typename?: "Receipt";
  adjustments: Array<ReceiptAdjustment>;
  amountDue: Scalars["Int"]["output"];
  contactDetails?: Maybe<ContactDetails>;
  currency: Scalars["String"]["output"];
  fulfillAt?: Maybe<Scalars["DateTime"]["output"]>;
  items: Array<ReceiptItem>;
  paidAt?: Maybe<Scalars["DateTime"]["output"]>;
  ref: Scalars["String"]["output"];
  subTotal: Scalars["Int"]["output"];
  taxExclusive: Scalars["Boolean"]["output"];
  taxTotal: Scalars["Int"]["output"];
  tenders: Array<ReceiptTender>;
  total: Scalars["Int"]["output"];
};

export type ReceiptAdjustment = {
  __typename?: "ReceiptAdjustment";
  amount: Scalars["Int"]["output"];
  label: Scalars["String"]["output"];
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ReceiptItem = {
  __typename?: "ReceiptItem";
  id?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  options: Array<ReceiptItemOption>;
  plu?: Maybe<Scalars["String"]["output"]>;
  quantity: Scalars["Int"]["output"];
  tax: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
  unitAmount: Scalars["Int"]["output"];
};

export type ReceiptItemChoice = {
  __typename?: "ReceiptItemChoice";
  name: Scalars["String"]["output"];
  options: Array<ReceiptItemOption>;
  quantity: Scalars["Int"]["output"];
  unitAmount: Scalars["Int"]["output"];
};

export type ReceiptItemOption = {
  __typename?: "ReceiptItemOption";
  choices: Array<ReceiptItemChoice>;
  name: Scalars["String"]["output"];
};

export type ReceiptTender = {
  __typename?: "ReceiptTender";
  amount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  refundAmount: Scalars["Int"]["output"];
};

/** Redeem code result extends a mutation result, but also provides message and title in the event of success */
export type RedeemCodeResult = MutationResult & {
  __typename?: "RedeemCodeResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the success message */
  messageDetails?: Maybe<MessageDetails>;
};

export type Reward = RewardCredit | RewardDiscount;

export type RewardCredit = {
  __typename?: "RewardCredit";
  amount: Scalars["Int"]["output"];
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  locations?: Maybe<Array<Location>>;
  remaining: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type RewardDiscount = {
  __typename?: "RewardDiscount";
  allocations?: Maybe<Array<RewardDiscountAllocation>>;
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  items?: Maybe<Array<RewardItem>>;
  locations?: Maybe<Array<Location>>;
  maxAmount?: Maybe<Scalars["Int"]["output"]>;
  maxRedemptionsPerCustomer?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  rate: Scalars["Float"]["output"];
  remainingRedemptionsPerCustomer?: Maybe<Scalars["Int"]["output"]>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
};

export type RewardDiscountAllocation = {
  __typename?: "RewardDiscountAllocation";
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
};

export type RewardItem = {
  __typename?: "RewardItem";
  id: Scalars["String"]["output"];
};

/** Extended information if the code provided a reward */
export type RewardMessageDetails = MessageDetails & {
  __typename?: "RewardMessageDetails";
  message: Scalars["String"]["output"];
  rewardType: PromotionRewardType;
  title: Scalars["String"]["output"];
};

/** Results for an activity query */
export type RewardResult = {
  __typename?: "RewardResult";
  /** The items for the query results */
  items: Array<Reward>;
  /** Pagination information */
  pageInfo?: Maybe<PageInfo>;
};

export enum ScannerBehaviour {
  /** Scanner will be available and displayed first/automatically */
  Auto = "AUTO",
  /** Scanner won't be available */
  Disabled = "DISABLED",
  /** Scanner will be available via a link below ref entry */
  Enabled = "ENABLED",
}

export type Session = {
  __typename?: "Session";
  appId?: Maybe<Scalars["String"]["output"]>;
  /** Deprecated. All features should be moved internal to Tidy API. */
  astonAccessToken?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  deviceId?: Maybe<Scalars["String"]["output"]>;
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  guest: Scalars["Boolean"]["output"];
  id?: Maybe<Scalars["String"]["output"]>;
  merchantId?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
  userRole?: Maybe<Scalars["String"]["output"]>;
  verified?: Maybe<Scalars["Date"]["output"]>;
};

export type SetupIntent = {
  __typename?: "SetupIntent";
  /** Secret for this setup intent, required for the Stripe mobile app and web SDKs */
  clientSecret: Scalars["String"]["output"];
};

export type SetupIntentResult = MutationResult & {
  __typename?: "SetupIntentResult";
  /** If unsuccessful this will be defined and indicates why the operation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the setup intent */
  intent?: Maybe<SetupIntent>;
};

export enum SpendAction {
  /** Connect payments */
  Connect = "CONNECT",
  /** Connect payments, then proceed to in store check in */
  ConnectInStore = "CONNECT_IN_STORE",
  /** Connect payments, then proceed to order ahead via web URL */
  ConnectOrderAhead = "CONNECT_ORDER_AHEAD",
  /** Connect payments, then proceed to order ahead via native UI */
  ConnectOrderAheadNative = "CONNECT_ORDER_AHEAD_NATIVE",
  /** Connect payments, then proceed to order at table via native UI */
  ConnectOrderAtTableNative = "CONNECT_ORDER_AT_TABLE_NATIVE",
  /** Connect payments, then proceed to pay at table */
  ConnectPayAtTable = "CONNECT_PAY_AT_TABLE",
  /** Check in to spend in store */
  InStore = "IN_STORE",
  /** Order ahead via a web URL */
  OrderAhead = "ORDER_AHEAD",
  /** Order ahead via the native UI */
  OrderAheadNative = "ORDER_AHEAD_NATIVE",
  /** Order at table via the native UI */
  OrderAtTableNative = "ORDER_AT_TABLE_NATIVE",
  /** Pay at table */
  PayAtTable = "PAY_AT_TABLE",
  /** View active transaction (in store check in) */
  ViewActive = "VIEW_ACTIVE",
}

export type SpendActivity = Activity & {
  __typename?: "SpendActivity";
  cart?: Maybe<Cart>;
  /** Unique ID */
  id: Scalars["String"]["output"];
  locationName: Scalars["String"]["output"];
  order: Order;
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

export type SpendHistoryItem = {
  __typename?: "SpendHistoryItem";
  /** Didn't think these were used but they are by a few old app versions. */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountLabel: Scalars["String"]["output"];
  amountText: Scalars["String"]["output"];
  discount?: Maybe<Scalars["String"]["output"]>;
  discountText: Scalars["String"]["output"];
  id?: Maybe<Scalars["String"]["output"]>;
  items?: Maybe<Array<SpendHistoryItemLineItem>>;
  location: Scalars["String"]["output"];
  /** PaymentMethodName should not be null for new transactions, but for old ones it is null. eg. ••••1234 or john@example.com. */
  paymentMethodName?: Maybe<Scalars["String"]["output"]>;
  /** PaymentMethodType should not be null for new transactions, but for old ones it is null. eg. visa, mastercard, paypal. */
  paymentMethodType?: Maybe<Scalars["String"]["output"]>;
  points?: Maybe<Scalars["Int"]["output"]>;
  pointsLabel: Scalars["String"]["output"];
  pointsText: Scalars["String"]["output"];
  pointsTextDetail: Scalars["String"]["output"];
  subtotal?: Maybe<Scalars["String"]["output"]>;
  subtotalText: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
};

export type SpendHistoryItemLineItem = {
  __typename?: "SpendHistoryItemLineItem";
  /** Didn't think these were used but they are by a few old app versions. */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountText: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  points?: Maybe<Scalars["Int"]["output"]>;
  quantity?: Maybe<Scalars["Int"]["output"]>;
  quantityText: Scalars["String"]["output"];
};

/** A spend option is typically represented by a button on the card list screen. */
export type SpendOption = {
  __typename?: "SpendOption";
  /** The action defines what to do when the button is pressed. */
  action: SpendAction;
  /**
   * True if the SpendAction is IN_STORE and the merchant requires a limit to be specified, null if action is not IN_STORE.
   * @deprecated No UI/business logic regarding this
   */
  hasLimit?: Maybe<Scalars["Boolean"]["output"]>;
  /** Label for this button. */
  label: Scalars["String"]["output"];
  /** Some options may have a number (check in number, order number, etc) associated with them. Null otherwise. */
  number?: Maybe<Scalars["String"]["output"]>;
  /** Some actions may have a URL associated with them. Null for others. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Standard response for a mutation */
export type StandardMutationResult = MutationResult & {
  __typename?: "StandardMutationResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

/** Contains an OrderSession just like CreateOrderResult */
export type StartPromotionRedemptionResult = MutationResult & {
  __typename?: "StartPromotionRedemptionResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

export type StringKeyValue = KeyValue & {
  __typename?: "StringKeyValue";
  dataType: ValueType;
  key: Scalars["String"]["output"];
  strValue?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type Strings = {
  __typename?: "Strings";
  /** Currently defaults to 'Earn 10 points on every $1 spent'. */
  noPointsText?: Maybe<Scalars["String"]["output"]>;
  /** Service Charge content */
  serviceChargeApply: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeBody: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeRemove: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeTitle: Scalars["String"]["output"];
  /** Retrieves Bill Payment language from office languages */
  webBillPaymentName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Checkin language from office languages */
  webCheckInName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Title for Location Selection landing page in web */
  webChooseLocationTitle?: Maybe<Scalars["String"]["output"]>;
  /** label for "Deals" */
  webDealsLabel: Scalars["String"]["output"];
  /** button label for paying externally for delivery (e.g. cash) */
  webExternalPaymentDeliveryButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for delivery */
  webExternalPaymentDeliveryMessage: Scalars["String"]["output"];
  /** button label for paying externally for pickup (e.g. cash) */
  webExternalPaymentPickUpButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for pickup */
  webExternalPaymentPickUpMessage: Scalars["String"]["output"];
  /** button label for paying externally for table service(e.g. cash) */
  webExternalPaymentServiceButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for table service */
  webExternalPaymentServiceMessage: Scalars["String"]["output"];
  /** Retrieves Delivery string from office languages */
  webOrderDeliveryName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Order Pick Up string from office languages */
  webOrderPickupName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Order Table Service string from office languages */
  webOrderServiceName?: Maybe<Scalars["String"]["output"]>;
  /** Label for placeRef ie: "Room Number" */
  webPlaceRefLabel: Scalars["String"]["output"];
  /** message shown after a submitted order transaction is confirmed */
  webPostTransactionSubmittedOrderPostMessage: Scalars["String"]["output"];
  /** message shown before a submitted order transaction is confirmed */
  webPostTransactionSubmittedOrderPreMessage: Scalars["String"]["output"];
  /** Label for serviceRef ie: "Table Number" */
  webServiceRefLabel: Scalars["String"]["output"];
  /** Message displayed if serviceRef not found */
  webServiceRefNotFoundMessage: Scalars["String"]["output"];
  /** label for "Voucher Code" (singular), e.g. "Code" */
  webVoucherCodeLabel: Scalars["String"]["output"];
};

/** Stripe Connect metadata */
export type StripeConnectMetadata = PaymentsMetadata & {
  __typename?: "StripeConnectMetadata";
  /** Display name for the gateway. Always Stripe Connect. */
  name: Scalars["String"]["output"];
  /** Stripe publishable key */
  publishableKey: Scalars["String"]["output"];
  /** Always STRIPE_CONNECT */
  type: PaymentsType;
};

/** Metadata specific to a STRIPE gateway. */
export type StripeMetadata = PaymentsMetadata & {
  __typename?: "StripeMetadata";
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Key needed for app to do tokenization. */
  publishableKey?: Maybe<Scalars["String"]["output"]>;
  /** Always STRIPE type. */
  type: PaymentsType;
};

export type SubmitUpsellSuggestionResult = MutationResult & {
  __typename?: "SubmitUpsellSuggestionResult";
  error?: Maybe<MutationError>;
  provider?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["String"]["output"]>;
};

/** SummaryItem */
export type SummaryItem = {
  __typename?: "SummaryItem";
  /** Amount of this summary item in lowest denomination (eg cents) */
  amount: Scalars["Int"]["output"];
  /** Label (sub-total, discount, credit, service charge) */
  label: Scalars["String"]["output"];
  /** Type Associated with the label (sub-total, discount, credit, service charge) */
  summaryItemType: SummaryItemType;
  /** Tax included in this summary item in lowest denomination */
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
};

/** Type of the Summary Items returned when creating an Order */
export enum SummaryItemType {
  /** The total credit applied to the order */
  Credit = "CREDIT",
  /** The cost amount of the customer platform fee (not applied to external payments) */
  CustomerFee = "CUSTOMER_FEE",
  /** The amount discounted from the order for an individual discount item */
  Discount = "DISCOUNT",
  /** The total cost of all the cart items in the order (including delivery) */
  ItemTotal = "ITEM_TOTAL",
  /** The difference of the ITEM_TOTAL and all the DISCOUNT items (not including credit) */
  Subtotal = "SUBTOTAL",
  /** The tip amount added to the order */
  Tip = "TIP",
}

/** Represents an unpaid bill assigned to a table. */
export type TableBill = {
  __typename?: "TableBill";
  /** The remaining to be paid on this bill (will be lower than total if existing payments have been made). Specified in lowest denomination of currency defined in `merchant.currency`. */
  balance: Scalars["Int"]["output"];
  /** Indicates whether the bill is closed and cannot accept further payments. */
  closed: Scalars["Boolean"]["output"];
  /** When the bill was created, nullable until bills v1 removed */
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique ID for this bill. */
  id: Scalars["String"]["output"];
  /** A list of items on this bill. These serve purely as metadata to allow the customer to identify the correct bill to be paid. */
  items: Array<TableBillItem>;
  /** A list of payment methods (eg: credit cards) available (will be empty list if user has not created a wallet). */
  payments?: Maybe<Array<TableBillPayment>>;
  /** Indicates whether this bill supports tip payments. If false then the tips UI should not be shown. */
  tipsAllowed: Scalars["Boolean"]["output"];
  /** The total to be paid on this bill. Specified in lowest denomination of currency defined in `merchant.currency. */
  total: Scalars["Int"]["output"];
  /** When the bill was last updated, nullable until bills v1 removed */
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

/** Represents a single line item on a table bill. */
export type TableBillItem = {
  __typename?: "TableBillItem";
  /** The per-quantity amount of this bill item. May be 0. Specified in lowest denomination of currency defined in `merchant.currency`. */
  amount: Scalars["Int"]["output"];
  /** Descriptive name for this item. */
  name: Scalars["String"]["output"];
  /** The quantity of this item. Must be greater than 0. The total amount for this line is `amount*quantity`. */
  quantity: Scalars["Int"]["output"];
  /** subItems - an array containing items with name and amount */
  subItems?: Maybe<Array<TableBillSubItem>>;
  /** Line item type */
  type: TableBillItemType;
};

/** The line item type for table bill items */
export enum TableBillItemType {
  /** Item adjustment */
  Adjustment = "ADJUSTMENT",
  /** Item discount */
  Discount = "DISCOUNT",
  /** Item */
  Item = "ITEM",
}

/** Standard response for a mutation + a bill */
export type TableBillMutationResult = MutationResult & {
  __typename?: "TableBillMutationResult";
  /** If success, return updated bill. Will be null if there is an error. */
  bill?: Maybe<TableBill>;
  /** If unsuccessful this will be set and indicates why the mutation failed. Will be null if successful. */
  error?: Maybe<MutationError>;
};

/** Payment done by user. */
export type TableBillPayment = {
  __typename?: "TableBillPayment";
  /** Amount paid off balance, ie total - tip. */
  amount: Scalars["Int"]["output"];
  /** Order Id for reference. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** Payment name. */
  name: Scalars["String"]["output"];
  /** Tip paid. */
  tip: Scalars["Int"]["output"];
  /** Total paid amount. */
  total: Scalars["Int"]["output"];
};

/** Represents a single line sub item on a table bill. */
export type TableBillSubItem = {
  __typename?: "TableBillSubItem";
  /** The per-quantity amount of this bill item. May be 0. Specified in lowest denomination of currency defined in `merchant.currency`. */
  amount: Scalars["Int"]["output"];
  /** Descriptive name for this item. */
  name: Scalars["String"]["output"];
};

export type TimeSlot = {
  __typename?: "TimeSlot";
  available: Scalars["Boolean"]["output"];
  endTime: Scalars["String"]["output"];
  ref: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export enum Tone {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export type Transaction = {
  __typename?: "Transaction";
  chargeTotal: Scalars["String"]["output"];
  completed?: Maybe<Scalars["Date"]["output"]>;
  created: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  lineItems?: Maybe<Array<TransactionItem>>;
  state: Scalars["String"]["output"];
  updated?: Maybe<Scalars["Date"]["output"]>;
};

export type TransactionItem = {
  __typename?: "TransactionItem";
  amount: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type UpsellCartInput = {
  items: Array<UpsellCartItemInput>;
};

export type UpsellCartItemInput = {
  lineItemId?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  options?: InputMaybe<Array<UpsellCartItemOptionInput>>;
  productId: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsellCartItemOptionInput = {
  choices?: InputMaybe<Array<UpsellCartItemInput>>;
  optionId: Scalars["String"]["input"];
};

export type UpsellSuggestedProduct = {
  __typename?: "UpsellSuggestedProduct";
  productId: Scalars["String"]["output"];
  suggestionDescription?: Maybe<Scalars["String"]["output"]>;
};

export type UpsellSuggestion = {
  __typename?: "UpsellSuggestion";
  suggestions?: Maybe<Array<UpsellSuggestedProduct>>;
};

export enum ValueType {
  Boolean = "BOOLEAN",
  Integer = "INTEGER",
  String = "STRING",
}

/** Wallet providers */
export enum Wallet {
  Androidpay = "ANDROIDPAY",
  Applepay = "APPLEPAY",
  Masterpass = "MASTERPASS",
}

/** TODO: Do we have a better name */
export type WebEmbeddedPaymentOption = PaymentOption & {
  __typename?: "WebEmbeddedPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type WebLink = {
  __typename?: "WebLink";
  href: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type WebOrderingPaymentOption = PaymentOption & {
  __typename?: "WebOrderingPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** TODO what should this actually be called */
  url: Scalars["String"]["output"];
};

export type WebPromotion = {
  __typename?: "WebPromotion";
  badgeText: Scalars["String"]["output"];
  claimButtonText?: Maybe<Scalars["String"]["output"]>;
  collectionDescription?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayOrder: Scalars["Int"]["output"];
  displayType?: Maybe<PromotionDisplayType>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  locations?: Maybe<Array<PromotionLocation>>;
  price?: Maybe<Scalars["Float"]["output"]>;
  priceType: PromotionPriceType;
  rewardType?: Maybe<PromotionRewardType>;
  title: Scalars["String"]["output"];
  type: PromotionType;
  url?: Maybe<Scalars["String"]["output"]>;
};
